import { Game } from "./engine/Game";

const canvas = document.getElementById("game-canvas") as HTMLCanvasElement;
const uiRoot = document.getElementById("ui-root") as HTMLDivElement;

if (!canvas || !uiRoot) {
  throw new Error("Missing canvas or ui-root in index.html");
}

// Prevent iPad bounce/scroll
document.addEventListener("gesturestart", (e) => e.preventDefault());
document.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false });

const game = new Game(canvas, uiRoot);
game.start();

// Hot-reload friendliness
if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
